module.exports = __webpack_public_path__ + "static/media/pro-down-bg.be1ce47f.png";